/**
 * Emit the bundle's `input` and Vue 3's `update:modelValue` together.
 *
 * The bundle's contract is `value` in and `input` out, and several hundred templates bind `@input` on a
 * `bs-*` component. Vue 3's `v-model="x"` compiles to `:modelValue` plus `@update:modelValue`, so a
 * component that emits only `input` leaves every v-model binding one-directional: the handler runs, the
 * bound variable never changes.
 *
 * `useBsComponent` does this for the value it emits itself; this is for the components that emit `input`
 * directly from a render or a method.
 *
 * ORDER MATTERS, and it is Vue 2's: there `v-model` and `@input` were two handlers for one event with
 * the model setter first, so a handler like `@input="filterBooks"` saw the NEW value. Emitting `input`
 * first reverses that, and a handler that re-reads the bound value gets the previous one.
 */
export const emitModel = (
  vm: { $emit: (event: string, ...args: unknown[]) => void },
  payload?: unknown
): void => {
  vm.$emit('update:modelValue', payload)
  vm.$emit('input', payload)
}
